import React from 'react';
import { WeaLocaleProvider } from 'ecCom';

const getLabel = WeaLocaleProvider.getLabel;
import Header from './Common/header';

export default class Content_addWF extends React.Component {
    render() {
        const { data = {}, eid } = this.props; <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@pr76u6`} data={data} eid={eid} />;
        const { moreLocal, iconMore, iconEsymbol } = data;
        const tr = (<tr className="element_prew_sparator" height="1px">
            <td colSpan="3" />
        </tr>);
        const tr1 = (
            <tr height="18">
                <td width="8"><img src="/images/homepage/style/style1/esymbol_wev8.gif" alt="" /></td>
                <td width="*"><a href="javascript:;"><font className="font">{getLabel(886, '资产领用')}</font></a></td>
            </tr>
        );
        const tr2 = (
            <tr height="18">
                <td width="8"><img src={iconEsymbol} alt="" /></td>
                <td width="*"><a href="javascript:;"><font className="font">{getLabel(501222, '会议申请') }</font></a></td>
            </tr>
        );
        const tr3 = (
            <tr height="18">
                <td width="8"><img src={iconEsymbol} alt="" /></td>
                <td width="*"><a href="javascript:;"><font className="font">{getLabel(501223, '内部留言') }</font></a></td>
            </tr>
        );
        const tr4 = (
            <tr height="18">
                <td width="8"><img src={iconEsymbol} alt="" /></td>
                <td width="*"><a href="javascript:;"><font className="font">{getLabel(1949, '费用报销') }</font></a></td>
            </tr>
        );
        const tr5 = (
            <tr height="18">
                <td width="8"><img src={iconEsymbol} alt="" /></td>
                <td width="*"><a href="javascript:;"><font className="font">{getLabel(83393, '请假流程') }</font></a></td>
            </tr>
        );
        return (
            <div className="item" id={`item_${eid}`}>
                <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@g9wqi1`} data={data} eid={eid} />
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view" id={`content_view_id_${eid}`}>
                        <div className="tab2">
                            <table height="32" cellSpacing="0" cellPadding="0">
                                <tr>
                                    <td className="tab2selected" style={{ width: '84px' }}>{getLabel(28184, '常用流程') }</td>
                                    <td className="tab2unselected" style={{ width: '84px' }}>{getLabel(18030, '我的收藏') }</td>
                                </tr>
                            </table>
                        </div>
                        <table width="100%">
                            {tr1}{tr}{tr2}{tr}{tr3}{tr}{tr4}{tr}{tr5}
                        </table>
                    </div>
                    <div className="footer" id={`footer_${eid}`} style={{ textAlign: 'right' }}>
                        {moreLocal == 'footer' ? <a href="javascript:;"><img src={iconMore} alt="" /></a> : ''}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_addWF.js